import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { onMounted, ref, watch } from "vue";
import cloneDeep from "lodash-es/cloneDeep";
import { styleZoom } from "@/common/utils/style";
// types
import type { ReportBlockType } from "@/common/types/report";


export default /*@__PURE__*/_defineComponent({
  __name: 'text-block',
  props: {
    block: {},
    selectedBlock: {},
    zoom: {}
  },
  emits: ["block:update"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const internalBlock = ref(cloneDeep(props.block));

watch(
  () => props.block,
  (newValue) => {
    internalBlock.value = cloneDeep(newValue);
  },
  { deep: true }
);

onMounted(() => {
  if (props.block) {
    internalBlock.value = cloneDeep(props.block);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "text-block",
    style: _normalizeStyle(_unref(styleZoom)(internalBlock.value?.style, __props.zoom))
  }, [
    _createElementVNode("div", {
      innerHTML: internalBlock.value.text
    }, null, 8, _hoisted_1)
  ], 4))
}
}

})